import { createActionTypes } from 'utils/action/actionTypes';

export const SHOW_SIDEBAR = createActionTypes('SHOW_SIDEBAR');
